import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/base/Breadcrumb';
import ScrollToTop from '@/components/base/ScrollToTop';

const breadcrumbItems = [
  { label: '首页', href: '/' },
  { label: '关于我们' },
];

const stats = [
  { value: '500万+', label: '日均阅读量', icon: 'ri-eye-line' },
  { value: '3000+', label: '独家爆料', icon: 'ri-article-line' },
  { value: '50万+', label: '忠实粉丝', icon: 'ri-heart-line' },
  { value: '365天', label: '全年无休更新', icon: 'ri-calendar-check-line' },
];

const testimonials = [
  {
    name: '匿名用户A',
    role: '忠实读者 · 3年',
    content: '黑料社是我每天的必读！信息更新快，内容劲爆，很多料都是别的地方看不到的。强烈推荐给所有八卦爱好者！',
    rating: 5,
  },
  {
    name: '吃瓜群众B',
    role: 'VIP会员',
    content: '自从关注了黑料社，再也不怕错过任何娱乐圈大瓜。独家内容真的太多了，几乎天天都有惊喜。',
    rating: 5,
  },
  {
    name: '娱乐圈观察者C',
    role: '资深用户 · 2年',
    content: '黑料社的内容质量在同类平台中绝对是顶尖的。深度揭秘文章特别精彩，看完了对娱乐圈有了全新的认识。',
    rating: 5,
  },
  {
    name: '爆料达人D',
    role: '活跃读者',
    content: '每一条独家爆料都很震撼！黑料社的编辑团队真的很有料，敢说真话。希望继续保持这种风格！',
    rating: 5,
  },
  {
    name: '深夜吃瓜E',
    role: '铁粉 · 1年',
    content: '内容更新速度超快，经常半夜都能看到新鲜出炉的爆料。页面设计也很清爽，阅读体验非常好。',
    rating: 4,
  },
  {
    name: '八卦研究员F',
    role: '忠实读者',
    content: '分类浏览功能很方便，可以快速找到自己感兴趣的爆料类型。每篇文章都有详细的来源和证据，非常专业。',
    rating: 5,
  },
];

export default function AboutPage() {
  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '黑料社',
    url: 'https://heiliao.com',
    description: '专注独家黑料爆料的聚合资讯平台',
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: '黑料社的内容来源是什么？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '黑料社的内容来源于专业调查团队的一手采访、匿名线人爆料、公开信息的深度挖掘以及合作媒体的内容共享。所有内容均经过交叉验证，确保信息的可信度。',
        },
      },
      {
        '@type': 'Question',
        name: '如何向黑料社提交爆料线索？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '您可以通过页面底部的联系表单提交爆料线索。我们承诺对所有爆料人的身份信息严格保密，并提供匿名爆料通道。',
        },
      },
      {
        '@type': 'Question',
        name: '黑料社的爆料内容是否真实可靠？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '黑料社坚持事实核查原则，所有爆料内容在发布前都经过了多轮交叉验证。我们标注有"独家"标签的内容均为本社调查团队一手获取的原始信息。',
        },
      },
      {
        '@type': 'Question',
        name: '黑料社更新频率如何？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '黑料社实行24小时滚动更新机制，每天至少发布10-15条新内容。重大爆料事件发生时，我们会进行实时追踪报道。',
        },
      },
    ],
  };

  return (
    <>
      <ScrollToTop />
      <script type="application/ld+json">{JSON.stringify(orgSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>

      <Navbar />
      <main className="pt-16">
        <div className="max-w-5xl mx-auto px-4 md:px-6">
          <Breadcrumb items={breadcrumbItems} />

          <section className="py-10 md:py-14">
            <div className="text-center mb-12">
              <div className="w-16 h-16 mx-auto rounded-full bg-primary-100 flex items-center justify-center mb-4">
                <i className="ri-spy-line text-primary-600 text-2xl"></i>
              </div>
              <h1 className="text-3xl md:text-4xl font-heading text-foreground-950 mb-4">
                关于黑料社
              </h1>
              <p className="text-foreground-500 max-w-2xl mx-auto leading-relaxed">
                黑料社成立于2023年，是国内领先的娱乐资讯聚合平台。我们致力于为读者提供最新、最全、最真实的娱乐圈内幕信息。
              </p>
            </div>

            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-14">
              {stats.map((stat) => (
                <div key={stat.label} className="text-center p-5 rounded-lg bg-background-100">
                  <div className="w-10 h-10 mx-auto rounded-full bg-accent-100 flex items-center justify-center mb-3">
                    <i className={`${stat.icon} text-accent-600`}></i>
                  </div>
                  <p className="text-2xl md:text-3xl font-bold text-foreground-900 mb-1">
                    {stat.value}
                  </p>
                  <p className="text-xs text-foreground-400">{stat.label}</p>
                </div>
              ))}
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-14">
              <div className="rounded-lg bg-background-100 p-6">
                <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center mb-3">
                  <i className="ri-lightbulb-line text-primary-600"></i>
                </div>
                <h2 className="text-lg font-heading text-foreground-900 mb-2">
                  我们的使命
                </h2>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  打破信息壁垒，让每一个普通人都能了解娱乐圈的真实面貌。我们相信，真相不应该被资本和权力所掩盖。黑料社始终站在读者一边，为大家揭开那些被精心包装的谎言。
                </p>
              </div>
              <div className="rounded-lg bg-background-100 p-6">
                <div className="w-10 h-10 rounded-full bg-accent-100 flex items-center justify-center mb-3">
                  <i className="ri-shield-check-line text-accent-600"></i>
                </div>
                <h2 className="text-lg font-heading text-foreground-900 mb-2">
                  我们的原则
                </h2>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  真实性第一：所有爆料内容严格核查；保护线人：绝不透露信息提供者身份；独立性：不受任何资本和利益集团操控；时效性：第一时间追踪报道热点事件。
                </p>
              </div>
            </div>
          </section>

          <section className="py-10 md:py-14 border-t border-foreground-100/60">
            <div className="text-center mb-10">
              <div className="w-12 h-12 mx-auto rounded-full bg-accent-100 flex items-center justify-center mb-3">
                <i className="ri-chat-heart-line text-accent-600 text-xl"></i>
              </div>
              <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-2">
                用户口碑
              </h2>
              <p className="text-sm text-foreground-400">看看大家怎么说</p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
              {testimonials.map((t, i) => (
                <div key={i} className="p-5 rounded-lg bg-background-100">
                  <div className="flex items-center gap-1 mb-3">
                    {Array.from({ length: 5 }).map((_, starIdx) => (
                      <i
                        key={starIdx}
                        className={`ri-star-fill text-sm ${starIdx < t.rating ? 'text-accent-500' : 'text-foreground-200'}`}
                      ></i>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                    "{t.content}"
                  </p>
                  <div className="flex items-center gap-3">
                    <div className="w-8 h-8 rounded-full bg-secondary-200 flex items-center justify-center">
                      <span className="text-xs text-secondary-700 font-bold">
                        {t.name.charAt(t.name.length - 1)}
                      </span>
                    </div>
                    <div>
                      <p className="text-sm font-medium text-foreground-800">{t.name}</p>
                      <p className="text-xs text-foreground-400">{t.role}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </section>

          <section className="py-10 md:py-14 border-t border-foreground-100/60">
            <div className="max-w-xl mx-auto">
              <div className="text-center mb-8">
                <div className="w-12 h-12 mx-auto rounded-full bg-secondary-100 flex items-center justify-center mb-3">
                  <i className="ri-mail-send-line text-secondary-600 text-xl"></i>
                </div>
                <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-2">
                  联系我们
                </h2>
                <p className="text-sm text-foreground-400">
                  有爆料线索？欢迎随时联系我们
                </p>
              </div>

              <form
                data-readdy-form=""
                action="https://readdy.ai/api/form/d9qruree3oq4jqumtprg"
                method="POST"
                className="space-y-4"
              >
                <div>
                  <label htmlFor="contact-name" className="block text-sm font-medium text-foreground-700 mb-1.5">
                    您的称呼
                  </label>
                  <input
                    type="text"
                    id="contact-name"
                    name="name"
                    required
                    className="w-full px-4 py-3 rounded-lg text-sm border border-foreground-200 bg-background-50 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-200 transition-colors"
                    placeholder="请输入您的称呼"
                  />
                </div>

                <div>
                  <label htmlFor="contact-email" className="block text-sm font-medium text-foreground-700 mb-1.5">
                    电子邮箱
                  </label>
                  <input
                    type="email"
                    id="contact-email"
                    name="email"
                    required
                    className="w-full px-4 py-3 rounded-lg text-sm border border-foreground-200 bg-background-50 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-200 transition-colors"
                    placeholder="请输入您的邮箱地址"
                  />
                </div>

                <div>
                  <label htmlFor="contact-topic" className="block text-sm font-medium text-foreground-700 mb-1.5">
                    反馈类型
                  </label>
                  <select
                    id="contact-topic"
                    name="topic"
                    required
                    className="w-full px-4 py-3 rounded-lg text-sm border border-foreground-200 bg-background-50 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-200 transition-colors"
                  >
                    <option value="">请选择反馈类型</option>
                    <option value="爆料投稿">爆料投稿</option>
                    <option value="内容反馈">内容反馈</option>
                    <option value="商务合作">商务合作</option>
                    <option value="其他咨询">其他咨询</option>
                  </select>
                </div>

                <div>
                  <label htmlFor="contact-message" className="block text-sm font-medium text-foreground-700 mb-1.5">
                    详细内容
                  </label>
                  <textarea
                    id="contact-message"
                    name="message"
                    required
                    maxLength={500}
                    rows={5}
                    className="w-full px-4 py-3 rounded-lg text-sm border border-foreground-200 bg-background-50 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-200 transition-colors resize-none"
                    placeholder="请输入您的详细内容（最多500字）"
                  ></textarea>
                  <p className="text-xs text-foreground-400 mt-1">最多500字</p>
                </div>

                <input
                  type="text"
                  name="company_alt"
                  autoComplete="off"
                  tabIndex={-1}
                  aria-hidden="true"
                  readOnly
                  className="form-honeypot"
                />

                <button
                  type="submit"
                  className="w-full py-3.5 bg-primary-500 text-white rounded-lg text-sm font-bold hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
                >
                  提交信息
                </button>
              </form>
            </div>
          </section>
        </div>
      </main>
      <Footer />
    </>
  );
}